import { CompanyModule } from './company-module.model';
import { OnboardingStatus } from './onboarding-status.model';
import { PageStyle } from './page-style.model';

export enum SignhostProvider {
  Nidaros = 0,
  Extern = 1
}

export enum IbanXSPaymentRequestUiMode {
  IbanXSHosted = 0,
  AIHubHosted = 1
}

export class Company {
  CompanyId: number;
  Name: string;
  Slug: string;
  SlugSuggestion: string;
  Address: string;
  PostalCode: string;
  City: string;
  IsActive: boolean;
  IBAN: string;
  CreditAmount: number;
  CreditAmountCurrency: string;
  IbanXSOnboardingFormCode: number;
  IbanXSOnboardingUrl: string;
  IsSuccessfullyOnboarded: boolean;
  OnboardingStatus: OnboardingStatus;
  CompanyModules: Array<CompanyModule>;
  PageStyles: Array<PageStyle>;
  PaymentRequestNumberOfDaysValid: number;
  PaymentRequestDefaultReturnUrl: string;
  IbanXSPaymentRequestUiMode: IbanXSPaymentRequestUiMode;
  SignhostPlatformProvider: SignhostProvider;
  SignhostProviderAPIKey: string;
  AllowAutoCreditUpdates: boolean;
  AutoCreditUpdateThreshold: number;
  AutoCreditUpdateAmount: number;
  ExactAccountId: string;
  PurchaseOrderNumber: string;
  IsUsingRPA: boolean;
  UseMolliePaymentLinkProvider: boolean;
  MollieProfileApiKey: string;

  constructor() {
    this.CompanyId = null;
    this.Name = null;
    this.Slug = null;
    this.SlugSuggestion = null;
    this.Address = null;
    this.PostalCode = null;
    this.City = null;
    this.IsActive = true;
    this.IBAN = null;
    this.CreditAmount = 0;
    this.CreditAmountCurrency = null;
    this.IbanXSOnboardingFormCode = 0;
    this.IbanXSOnboardingUrl = null;
    this.IsSuccessfullyOnboarded = null;
    this.OnboardingStatus = new OnboardingStatus();
    this.CompanyModules = new Array<CompanyModule>();
    this.PageStyles = new Array<PageStyle>();
    this.PaymentRequestNumberOfDaysValid = 7;
    this.PaymentRequestDefaultReturnUrl = null;
    this.IbanXSPaymentRequestUiMode = IbanXSPaymentRequestUiMode.IbanXSHosted;
    this.SignhostPlatformProvider = SignhostProvider.Nidaros;
    this.SignhostProviderAPIKey = null;
    this.AllowAutoCreditUpdates = false;
    this.AutoCreditUpdateThreshold = 25;
    this.AutoCreditUpdateAmount = 25;
    this.ExactAccountId = null;
    this.PurchaseOrderNumber = null;
    this.IsUsingRPA = false;
    this.UseMolliePaymentLinkProvider = false;
    this.MollieProfileApiKey = null;
  }
}

export let CompanyIgnoreList: any[] = [
  'SlugSuggestion',
];
